module.exports = __webpack_public_path__ + "static/media/place_sections_generate_schedule_screen.5f23ec1c.png";